export default [
  // 销售经理工作台
  {
    path: '/firstPage',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/loud/firstPage/firstPage.vue'),
    meta: {
      title: '销售经理工作台',
      isTabsPage: true,
      keepAlive: true
    }
  },
  // 国内市场小微主工作台
  {
    path: '/secondPage',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/loud/firstPage/secondPage.vue'),
    meta: {
      title: '小微主工作台',
      isTabsPage: true,
      keepAlive: true
    }
  },
  // 财务经理工作台
  {
    path: '/thirdPage',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/loud/firstPage/thirdPage.vue'),
    meta: {
      title: '财务经理工作台',
      isTabsPage: true,
      keepAlive: true
    }
  },
  // 经销商工作台
  {
    path: '/fourthPage',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/loud/firstPage/fourthPage.vue'),
    meta: {
      title: '经销商工作台',
      isTabsPage: true,
      keepAlive: true
    }
  },
  {
    path: '/dashboard',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/homeBoard/dashboard.vue'),
    meta: {
      title: '经销商工作台',
      isTabsPage: true,
      keepAlive: true
    }
  },

  {
    path: '/agentBoardList',
    // which is lazy-loaded when the route is visited.
    component: () => import('@/views/homeBoard/agentBoardList.vue'),
    meta: {
      title: '网络诊断列表',
      isTabsPage: true,
      keepAlive: true
    }
  },

]
